import { render, staticRenderFns } from "./DefaultHeader.vue?vue&type=template&id=ecdc5acc&scoped=true&"
import script from "./DefaultHeader.vue?vue&type=script&lang=js&"
export * from "./DefaultHeader.vue?vue&type=script&lang=js&"
import style0 from "./DefaultHeader.vue?vue&type=style&index=0&id=ecdc5acc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdc5acc",
  null
  
)

export default component.exports